import {Component} from 'react'
import {Route, Redirect, Switch} from 'react-router-dom'
import {formatDistanceToNow} from 'date-fns'

import AppContext from './context/AppContext'

import Login from './components/Login'
import ProtectedRoute from './components/ProtectedRoute'
import Home from './components/Home'
import VideoItemDetails from './components/VideoItemDetails'
import Trending from './components/Trending'
import SavedVideos from './components/SavedVideos'
import Gaming from './components/Gaming'
import NotFound from './components/NotFound'

import './App.css'

// Replace your code here
class App extends Component {
  state = {
    theme: false,
    isSideBarVisible: false,
    isBannerVisible: true,
    isliked: false,
    isDisliked: false,
    isSaved: false,
    savedVideoList: [],
  }

  onClickToggleBanner = () => {
    this.setState(prevState => ({
      isBannerVisible: !prevState.isBannerVisible,
    }))
  }

  onClickUpdateSideBar = () => {
    this.setState(prevState => ({
      isSideBarVisible: !prevState.isSideBarVisible,
    }))
  }

  onClickChangeTheme = () => {
    this.setState(prevState => ({
      theme: !prevState.theme,
    }))
  }

  onClickLikeBtn = () => {
    const {isliked} = this.state
    const udisliked = isliked === true && false
    this.setState({
      isliked: !isliked,
      isDisliked: udisliked,
    })
  }

  onClickDislikeBth = () => {
    const {isDisliked} = this.state
    const uliked = isDisliked === true && false
    this.setState({
      isDisliked: !isDisliked,
      isliked: uliked,
    })
  }

  onClickSaveBtn = newVideoItem => {
    this.setState(
      prevState => ({
        isSaved: !prevState.isSaved,
      }),
      () => {
        this.changeSavedList(newVideoItem)
      },
    )
  }

  changeSavedList = newVideoItem => {
    const {isSaved, savedVideoList} = this.state

    if (isSaved) {
      this.setState(prevState => ({
        savedVideoList: [...prevState.savedVideoList, newVideoItem],
      }))
    } else {
      const newList = savedVideoList.filter(each => each.id !== newVideoItem.id)
      this.setState({
        savedVideoList: newList,
      })
    }
  }

  duration = date => {
    const k = formatDistanceToNow(new Date(date))
    return k
  }

  render() {
    const {
      theme,
      isSideBarVisible,
      isBannerVisible,
      savedVideoList,
      isliked,
      isDisliked,
      isSaved,
    } = this.state
    return (
      <AppContext.Provider
        value={{
          theme,
          isSideBarVisible,
          isBannerVisible,
          savedVideoList,
          isliked,
          isDisliked,
          isSaved,
          onClickChangeTheme: this.onClickChangeTheme,
          onClickUpdateSideBar: this.onClickUpdateSideBar,
          onClickToggleBanner: this.onClickToggleBanner,
          duration: this.duration,
          onClickLikeBtn: this.onClickLikeBtn,
          onClickDislikeBth: this.onClickDislikeBth,
          onClickSaveBtn: this.onClickSaveBtn,
        }}
      >
        <Switch>
          <Route exact path="/login" component={Login} />
          <ProtectedRoute exact path="/" component={Home} />
          <ProtectedRoute
            exact
            path="/videos/:id"
            component={VideoItemDetails}
          />
          <ProtectedRoute exact path="/trending" component={Trending} />
          <ProtectedRoute exact path="/saved-videos" component={SavedVideos} />
          <ProtectedRoute exact path="/gaming" component={Gaming} />
          <NotFound exact path="/not-found" component={NotFound} />
          <Redirect to="/not-found" />
        </Switch>
      </AppContext.Provider>
    )
  }
}

export default App
